<template>
  <div class="pipe-list bg-transparent rounded-2px z-99 w-full h-full pt-10px">
    <el-table
      ref="markerTable"
      :data="tableData"
      class="markerTable mt-10px"
      height="calc(100% - 10px)"
      :cell-style="{ 'text-align': 'center' }"
      :header-cell-style="{ 'text-align': 'center' }"
      highlight-current-row
      @row-click="rowClick"
      v-loading="tableLoading"
    >
      <el-table-column show-overflow-tooltip type="index" label="序号" width="50"></el-table-column>
      <el-table-column show-overflow-tooltip prop="name" label="阀门名称"></el-table-column>
      <el-table-column label="操作" width="80">
        <template slot-scope="scope">
          <span @click.stop="checkDetail(scope.row)" class="cursor-pointer">查看</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { ThreeDimensionsApi } from '@wiz-api/guang-xi-shi-hua'
import { Base64 } from 'js-base64'

const threeDimensionsApi = new ThreeDimensionsApi()
export default {
  components: {},
  props: {
    player: {
      type: Object,
      default: () => {
        return {}
      },
    },
    transferProps: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      tableLoading: false,
      tableData: [],
    }
  },
  watch: {
    'transferProps.code': {
      handler(newVal, oldVal) {
        if (newVal) {
          this.getValveList()
        }
      },
    },
  },
  computed: {},
  async created() {
    if (this.transferProps.code) {
      this.getValveList()
    }
  },
  methods: {
    // 获取阀门清单
    async getValveList() {
      this.tableLoading = true
      try {
        const itemInfo = await this.player.Native.ModelTree.getItemByCode(this.transferProps.code)
        const childrenList = []
        if (itemInfo?.item) {
          const subItems = await this.player.Native.ModelTree.getSubItems(itemInfo.item)
          if (subItems?.length) {
            childrenList.push(...subItems)
            for (let i = 0; i < subItems.length; i += 1) {
              if (subItems[i].item) {
                childrenList.push(
                  // eslint-disable-next-line no-await-in-loop
                  ...(await this.player.Native.ModelTree.getSubItems(subItems[i].item))
                )
              }
            }
          }
        }
        await Promise.all(childrenList)
        const valveList = await this.getAllValveList()
        const valveListInModel = _.filter(childrenList, (item) => {
          return item.code.indexOf('Valve') > -1
        })
        if (valveListInModel.length || valveList.length) {
          _.forEach(valveListInModel, (item) => {
            const index = _.findIndex(valveList, ['code', item.code])
            if (index === -1) {
              valveList.push({
                ...item,
                classId: '',
              })
            }
          })
          this.tableData = valveList
        } else {
          this.tableData = []
        }
        this.tableLoading = false
      } catch (error) {
        this.tableLoading = false
      }
    },
    async getAllValveList() {
      const [err, res] = await threeDimensionsApi.getValveList({
        code: this.transferProps.code,
      })
      if (!err && res?.code && res.code === '200' && res.data) {
        return res.data
      }
      return []
    },
    // 行点击
    async rowClick(row) {
      const itemInfo = await this.player.Native.ModelTree.getItemByCode(row.code)
      if (itemInfo?.item) {
        this.player.Native.ModelTree.setSelectItem(itemInfo.item)
        this.player.Native.Camera.moveToItem(itemInfo.item, 2)
      }
    },
    // 查看详情
    async checkDetail(row) {
      const filterEvent = new CustomEvent('gxDialogControl', {
        detail: {
          ...row,
          currentDialog: 'valve',
        },
      })
      window.dispatchEvent(filterEvent)
    },
  },
}
</script>
<style lang="scss" scoped>
.markerTable {
  ::v-deep .el-checkbox {
    margin: 0 !important;
  }
  ::v-deep .el-table th.is-leaf,
  .el-table td {
    border: none !important;
  }
}
</style>
